export default "__VITE_ASSET__CHE5V5lG__"